import { Button, Flex } from '@chakra-ui/react';
import { FC } from 'react';
import { ChevronLeftIcon } from 'src/utils/icons/chevronLeft';
import { ChevronRightIcon } from 'src/utils/icons/chevronRight';

export enum Side {
	LEFT,
	RIGHT,
}

interface Props {
	side: Side;
	action: () => void;
}

export const ArrowButton: FC<Props> = ({ side, action }) => {
	const sideOptions = {
		[Side.LEFT]: () => <ChevronLeftIcon />,
		[Side.RIGHT]: () => <ChevronRightIcon />,
	};

	return (
		<Flex
			pos="absolute"
			top="12%"
			align="center"
			w="46px"
			h="100%"
			left={side === Side.LEFT ? '-30px' : 'auto'}
			right={side === Side.RIGHT ? '-30px' : 'auto'}
			zIndex={2}
		>
			<Button
				onClick={action}
				variant="circle"
			>
				{sideOptions[side]()}
			</Button>
		</Flex>
	);
};
